import React from 'react';

const Loading = () => {
    return (
        <div className="loading block">
            <h1 className="text-2xl my-4 text-neutral-700">loading...</h1>
        </div>
    );
};

export default Loading;